import { FC, useCallback } from 'react';

import { BaseChips } from 'components/common/CompositeSelection/components/BaseChips';
import { useCompositeSelectionContext } from 'components/common/CompositeSelection/contexts';

interface CompositeSelectionExcludedChipsProps {
    containerDataQa: string;
    size?: 'small' | 'extra-small';
    title?: string;
}

const CompositeSelectionExcludedChips: FC<CompositeSelectionExcludedChipsProps> = ({
    containerDataQa,
    size = 'small',
    title,
}) => {
    const { excludedValue = [], onChange } = useCompositeSelectionContext();

    const handleDelete = useCallback(
        (id: string) => {
            onChange((prev) => ({
                value: prev.value,
                excludedValue: (prev.excludedValue || []).filter((excludedId) => excludedId !== id),
            }));
        },
        [onChange]
    );

    return (
        <BaseChips
            sourceValue={excludedValue}
            onDelete={handleDelete}
            containerId="excluded-chips-container"
            containerDataQa={containerDataQa}
            size={size}
            title={title}
        />
    );
};

export { CompositeSelectionExcludedChips };
